module.exports = __webpack_public_path__ + "static/media/stop.18538452.png";